import {
  activeDomainFromEmail,
  forgotPasswordEmail,
  forgotPasswordMobile,
  getCheckCode,
  getDomain,
  login,
  loginByDomain,
  modifyPassword,
  msmValidate,
  registerDomain,
  validateDomain,
  validateUser,
  getFlagWithVerifyCode
} from '../services/login';
import { routerRedux } from 'dva/router';
import PromptInfo from '../utils/promptInfo.js';
import {
  CHINESE,
  FIND_PASSWORD,
  OPEN_LOGIN,
  OPEN_SIGN,
  PATH_HOME,
  PATHS,
  REST_PASSWORD
} from '../utils/constants';
import { message } from 'antd';
import openDialog from '../components/commons/ScheduleDialog';

const DialogType = PromptInfo.DialogType;
const DialogResult = PromptInfo.DialogResult;

const stateDef = {
  token: '',
  userInfo: {},
  error: { type: '', msg: '' }, //登录时的异常记录
  divType: OPEN_LOGIN,
  register: { info: null },
  registerError: { tips: Array(7), msg: '' },
  domainName: '',
  msm: { minutes: 61, validCode: '' },
  domainInfo: {},
  findPassword: { mobile: '', email: '', tips: '', verifyCode: '', info: '' },
  restUser: {},
  newPassword: { pwd: '', pwd1: '', tips: '' },
  registerMobile: '',
  isFlag: false,
  checkCodeVisible: true,
  ...{
    //登录信息
    account: '', //账号
    checkCode: '', //前台输入的验证码
    checkCodeKey: '', //后台生成验证码对应的key
    checkCodeImg: '' //后台生成的验证码图片的base64编码
  }
};

export default {
  namespace: 'login',
  state: { ...stateDef },
  reducers: {
    clear() {
      return { ...stateDef };
    },
    setToken(state, { token }) {
      return { ...state, token };
    },
    setUserInfo(state, { userInfo }) {
      return { ...state, userInfo };
    },
    setError(state, { error }) {
      return { ...state, error };
    },
    setDivType(state, { divType }) {
      return { ...state, divType };
    },
    setRegister(state, { register }) {
      return { ...state, register };
    },
    setRegisterMobile(state, { registerMobile }) {
      return { ...state, registerMobile };
    },
    setRegisterError(state, { registerError }) {
      return { ...state, registerError };
    },
    setDomainName(state, { domainName }) {
      return { ...state, domainName };
    },
    setMsm(state, { msm }) {
      state.msm = { ...state.msm, ...msm };
      return { ...state };
    },
    updateMsm(state) {
      let { msm } = state;
      msm.minutes = msm.minutes - 1;
      return { ...state, msm };
    },
    setDomainInfo(state, { domainInfo }) {
      return { ...state, domainInfo };
    },
    setFindPassword(state, { findPassword }) {
      return { ...state, findPassword };
    },
    setFindPasswordInfo(state, { info }) {
      return { ...state, findPassword: { ...state.findPassword, info } };
    },
    setRestUser(state, { restUser }) {
      return { ...state, restUser };
    },
    setNewPassword(state, { newPassword }) {
      return { ...state, newPassword };
    },
    isFlag(state, { isFlag }) {
      return { ...state, isFlag };
    },
    update(state, { payload }) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *userLogin(
      {
        payload: { username, password, basedn, checkCodeVisible=true }
      },
      { call, put, select }
    ) {
      const locale = yield select(state => state.i18n.locale);
      const { checkCode, checkCodeKey } = yield select(state => state.login);
      //1-可见，0-不可见
      let checkCodeFlag = 1;
      if(!checkCodeVisible){
        checkCodeFlag = 0;
      }
      const data = yield call(login, {
        username,
        password,
        checkCode,
        checkCodeKey,
        locale,
        checkCodeFlag
      });
      if (data.status === 0) {
        yield put({ type: 'setToken', token: data.token });
        yield put({ type: 'setUserInfo', userInfo: data.userInfo });
        yield put({
          type: 'setDomainName',
          domainName: data.userInfo.domainName
        });
        sessionStorage.setItem('token', data.token);
        sessionStorage.setItem('userInfo', JSON.stringify(data.userInfo));
        sessionStorage.setItem('domainName', data.userInfo.domainName);
        yield put({ type: 'redirectAfterLogin' });
      } else {
        yield put({
          type: 'setError',
          error: { type: PromptInfo.USER_INVALID, msg: data.msg }
        });
        yield put({ type: 'getCheckCode' });
      }
    },
    *validateDomain({ domainName }, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const data = yield call(validateDomain, { domainName, locale });
      if (data.status === 0) {
        yield put({ type: 'setDomainName', domainName });
      } else {
        yield call(openDialog, {
          type: DialogType.ERROR,
          message: data.msg,
          locale: locale
        });
        yield put({ type: 'setDomainName', domainName: '' });
        let registerError = yield select(state => state.login.registerError);
        registerError.msg = data.msg;
        registerError.tips[1] = <i className="iconfont icon-x" />;
        yield put({ type: 'setRegisterError', registerError });
      }
    },
    *validateUser({ user }, { call, select, put }) {
      const locale = yield select(state => state.i18n.locale);
      const token = yield select(state => state.login.token);
      const data = yield call(validateUser, { user, locale, token });
      if (data.status === 1) {
        yield call(openDialog, {
          type: DialogType.ERROR,
          message: data.msg,
          locale: locale
        });
        let registerError = yield select(state => state.login.registerError);
        registerError.msg = data.msg;
        registerError.tips[user.flag === 2 ? 5 : 4] = (
          <i className="iconfont icon-x" />
        );
        yield put({ type: 'setRegisterError', registerError });
      }
    },
    *registerDomain({ noticeType }, { call, select, put }) {
      let register = yield select(state => state.login.register);
      register.noticeType = noticeType;
      const locale = yield select(state => state.i18n.locale);
      const token = yield select(state => state.login.token);
      const data = yield call(registerDomain, { register, locale, token });
      if (data.status === 1) {
        const e = yield call(openDialog, {
          type: DialogType.ERROR,
          message: data.msg,
          locale: locale
        });
        if (e === DialogResult.OK) {
          yield put({ type: 'setDivType', divType: OPEN_SIGN });
          delete register.verifyCode;
          delete register.info;
          yield put({ type: 'setRegister', register });
        }
      } else {
        const e = yield call(openDialog, {
          type: DialogType.SUCCESS,
          message: data.data,
          locale: locale
        });
        if (e === DialogResult.OK) {
          yield put({ type: 'setDivType', divType: OPEN_LOGIN });
          yield put({ type: 'setRegister', register: {} });
        }
      }
    },
    //判断是否要跳转flag：flag 标志位(0-域激活验证码获取|1-密码重置验证码获取)
    *msmValidate(
      {
        payload: { mobile, domainName, flag }
      },
      { call, select, put }
    ) {
      const { locale, messages } = yield select(state => state.i18n);
      const { findPassword, account, checkCode, checkCodeKey } = yield select(
        state => state.login
      );

      const checkCodeVisible = yield select(state => state.login.checkCodeVisible);
      //1-可见，0-不可见
      let checkCodeFlag = 1;
      if (!checkCodeVisible) {
        checkCodeFlag = 0;
      }

      if (flag === 1 && !account) {
        yield put({
          type: 'setFindPassword',
          findPassword: { ...findPassword, tips: messages['index_un_username'] }
        });
        return;
      }
      const register = yield select(state => state.login.register);
      const data = yield call(msmValidate, {
        mobile,
        domainName,
        flag,
        locale,
        account,
        checkCode,
        checkCodeKey,
        checkCodeFlag
      });
      if (data.status === 0) {
        const msm = yield select(state => state.login.msm);
        msm.minutes = 60;
        msm.validCode = mobile;
        yield put({ type: 'setMsm', msm: msm });
        yield put({ type: 'isFlag', isFlag: true });
        yield call(openDialog, {
          type: DialogType.SUCCESS,
          message: data.data,
          locale: locale
        });
        if (flag === 1) {
          yield put({
            type: 'setFindPassword',
            findPassword: {
              ...findPassword,
              info: `${messages['code_tips']} ${mobile.substring(
                0,
                3
              )}*****${mobile.substring(8)}`
            }
          });
        } else if (flag === 0) {
          yield put({
            type: 'setRegister',
            register: {
              ...register,
              info: `${messages['code_tips']} ${mobile.substring(
                0,
                3
              )}*****${mobile.substring(8)}`
            }
          });
          yield put({ type: 'setRegisterMobile', registerMobile: '' });
        }
      } else {
        yield put({ type: 'getCheckCode' });
        yield put({ type: 'isFlag', isFlag: false });
        yield put({ type: 'setMsm', msm: { minutes: 61 } });
        yield call(openDialog, {
          type: DialogType.ERROR,
          message: data.msg,
          locale: locale
        });
      }
    },
    *getDomain({ domainName }, { call, select, put }) {
      const locale = yield select(state => state.i18n.locale);
      const result = yield call(getDomain, { domainName, locale });
      if (result && result.status === 0) {
        //这里只负责处理正确的情况
        sessionStorage.setItem('domainName', result.data.domain);
        //如果domainName不存在时，返回到404页面
        if (result.data.domain !== domainName) {
          yield put(routerRedux.push(`${PATH_HOME}undefined`));
        } else {
          yield put({ type: 'setDomainName', domainName: domainName });
          yield put({ type: 'setDomainInfo', domainInfo: result.data });
        }
      } else {
        yield put(routerRedux.push(`${PATH_HOME}undefined`));
      }
    },
    *activeDomain(
      {
        payload: { email, domainName }
      },
      { call, put, select }
    ) {
      const locale = yield select(state => state.i18n.locale);
      const result = yield call(activeDomainFromEmail, {
        locale,
        email,
        domainName
      });
      if (result && result.status === 1) {
        yield call(openDialog, {
          type: DialogType.ERROR,
          message: result.msg,
          locale: locale
        });
      } else if (result && result.status === 0) {
        const e = yield call(openDialog, {
          type: DialogType.SUCCESS,
          message: result.data,
          locale: locale
        });
        if (e === DialogResult.OK) {
          yield put({ type: 'setDivType', divType: OPEN_LOGIN });
        }
      }
    },
    *findPassword({ flag }, { call, put, select }) {
      const { findPassword, account, checkCode, checkCodeKey } = yield select(
        state => state.login
      );
      const mobile = yield select(state => state.login.msm.validCode);
      const checkCodeVisible = yield select(state =>state.login.checkCodeVisible);
      const { messages, locale } = yield select(state => state.i18n);
      if (!account) {
        yield put({
          type: 'setFindPassword',
          findPassword: { ...findPassword, tips: messages['index_un_username'] }
        });
        return;
      }
      if (
        flag === 0 &&
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/gi.test(findPassword.email)
      ) {
        yield put({
          type: 'setFindPassword',
          findPassword: {
            ...findPassword,
            tips: messages['email_error_prompt']
          }
        });
        return;
      }
      //1-可见，0-不可见
      let checkCodeFlag = 1;
     
      if (!checkCodeVisible) {
        checkCodeFlag = 0;
      }

      let result = '';
      console.log('flag',flag);
      if (flag === 0) {
        //发送邮件需要带上校验码
        result = yield call(forgotPasswordEmail, {
          num: findPassword.email,
          locale,
          account,
          verifyCode: checkCode,
          key: checkCodeKey,
          checkCodeFlag: checkCodeFlag
        });
      } else {
        //短信
        result = yield call(forgotPasswordMobile, {
          num: mobile,
          locale,
          account,
          verifyCode: findPassword.verifyCode
        });
      }
      if (result && result.status === 1) {
        yield call(openDialog, {
          type: DialogType.ERROR,
          message: result.msg,
          locale: locale
        });
      } else if (result && result.status === 0) {
        if (flag === 0) {
          // 0-邮箱重置密码|1-短信重置密码
          yield call(openDialog, {
            type: DialogType.SUCCESS,
            message: messages['emil_sent'],
            locale: locale
          });
        } else {
          yield put({ type: 'setDivType', divType: REST_PASSWORD });
          yield put({ type: 'setRestUser', restUser: result.data });
        }
      }
      if (flag === 0) {
        // 0-邮箱重置密码

        if(checkCodeFlag==1){//验证码可见
          yield put({ type: 'getCheckCode' });
        }
      }
    },
    *reSetPassword({ pwd }, { call, put, select }) {
      const { locale, messages } = yield select(state => state.i18n);
      const { restUser } = yield select(state => state.login);
      const result = yield call(modifyPassword, {
        pwd,
        locale,
        resetType: restUser.resetType,
        userId: `${restUser.userId}@${restUser.domainName}`
      });
      if (result.status === 0) {
        const e = yield call(openDialog, {
          type: DialogType.SUCCESS,
          message: messages['index_save_success'],
          locale: locale
        });
        if (e === DialogResult.OK) {
          yield put({ type: 'setDivType', divType: OPEN_LOGIN });
          yield put({ type: 'setNewPassword', newPassword: {} });
        }
      } else {
        const e = yield call(openDialog, {
          type: DialogType.ERROR,
          message: result.msg,
          locale: locale
        });
        if (e === DialogResult.OK || e === DialogResult.CANCEL) {
          yield put({ type: 'setDivType', divType: FIND_PASSWORD });
        }
      }
      yield put({ type: 'setFindPasswordInfo', info: '' });
    },
    *getCheckCode(_, { call, put }) {
      //这里查库里面的配置，需要显示验证码的标记
      const resultFlag = yield call(getFlagWithVerifyCode);
      if (resultFlag.status === 0) {
        if (resultFlag.data.flag === 0) {//不显示验证码
          yield put({ type: 'update', payload: { checkCodeVisible: false } });
        } else {//显示验证码
          const result = yield call(getCheckCode);
          if (result.status === 0) {
            yield put({
              type: 'update',
              payload: {
                checkCodeImg: `data:image/png;base64,${result.data.code}`,
                checkCodeKey: result.data.key,
                checkCode: ''
              }
            });
          } else {
            yield put({
              type: 'update',
              payload: { checkCodeImg: null, checkCodeKey: null }
            });
          }
        }
      } else {
        console.log('获取后台验证码配置失败');
        return;
      }
      yield put({ type: 'setFindPasswordInfo', info: '' });
    },
    *redirectAfterLogin(_, { put, select, take }) {
      //登录后找到当前角色的第一个有效menu菜单，然后跳转过去
      const { userInfo } = yield select(state => state.login);
      let redirectPath = PATHS.blank; //给个默认空白路由，避免有那种没有任何权限的角色
      yield put({ type: 'role/findAllRoles' });
      yield take('findAllRoles@@end');
      const { roleMenus = [] } = yield select(state => state.role);
      const roleMenu = roleMenus.find(
        roleMenu => roleMenu.id === userInfo.roleId
      );
      const { menus = [] } = roleMenu || {};
      const menu = menus.find(menu => {
        const path = `${PATH_HOME}${menu.url}`;
        if (path !== PATHS.account && path !== PATHS.report) {
          return menu;
        }
      });
      if (menu) {
        redirectPath = `${PATH_HOME}${menu.url}`;
      }
      yield put(routerRedux.push(redirectPath));
    },
    *loginByDomain({ domain, password }, { call, put }) {
      const { status, token, userInfo, msg ,licenseExpire = 0} = yield call(loginByDomain, {
        domain,
        password
      });
      if (status === 0) {
        yield put({ type: 'i18n/setLocale', locale: CHINESE })
        yield put({ type: 'setToken', token });
        yield put({ type: 'setUserInfo', userInfo });
        yield put({ type: 'setDomainName', domainName: domain });
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
        sessionStorage.setItem('domainName', domain);
        if(licenseExpire === 0){
          yield put(routerRedux.push(PATHS.sysParam));
        }else{
          yield put(routerRedux.push(PATHS.license));
        }
      } else {
        message.error(msg);
      }
    }
  },

  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname, query }) => {
        if (pathname.indexOf(PATH_HOME) > -1) {
          dispatch({ type: 'setError', error: { type: '', msg: '' } });
          dispatch({ type: 'setDivType', divType: OPEN_LOGIN });
          dispatch({ type: 'setRegister', register: {} });
          dispatch({
            type: 'setRegisterError',
            registerError: { tips: Array(7), msg: '' }
          });
          if (sessionStorage.getItem('token')) {
            dispatch({
              type: 'setToken',
              token: sessionStorage.getItem('token')
            });
            dispatch({
              type: 'setUserInfo',
              userInfo: JSON.parse(sessionStorage.getItem('userInfo'))
            });
          }
        }
        if (pathname === PATH_HOME) {
          dispatch({ type: 'getCheckCode' });
        }
        if(pathname.indexOf(PATHS.sysConfig) > -1) {
          dispatch({ type: 'i18n/setLocale', locale: CHINESE })
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/login.js